// @ai-generated 2026-08-21T00:00:00Z by niklas.eicker@tngtech.com using Claude Opus 5 (1M context)
import { readToolResultPayload } from '@utils/toolCallEnvelope';
import { resolveToolCallState, type ToolCallState } from './toolCallStatus';

/**
 * A workflow reports itself in prose rather than through the `Result<T>` envelope the commands use,
 * so there is no `isError` and no messages to read — the run's own wording is the only signal that
 * it did not finish. Matching it is a stopgap; a workflow tool that returned a structured result
 * would replace this and let the card show the run's steps.
 */
const FAILURE_MARKER = 'fehlgeschlagen';

export interface WorkflowToolStatus {
    state: ToolCallState;
    /** The run's own account of what it did, when it sent one. */
    report: string | undefined;
}

/** Reads the prose report and the outcome it implies, which the shared status vocabulary cannot see. */
export function resolveWorkflowToolStatus(status: unknown, result: unknown): WorkflowToolStatus {
    const state = resolveToolCallState(status, result);
    // A bare string arrives quoted and with its line breaks escaped, so reading it raw printed a
    // literal "\n\n" between the narration and the failing step's cause.
    const payload = readToolResultPayload(result);
    const report = typeof payload === 'string' ? payload.trim() : undefined;
    const failed = report !== undefined && report.includes(FAILURE_MARKER);

    return {
        state: failed ? asFailed(state) : state,
        report: report !== undefined && report !== '' ? report : undefined,
    };
}

/** Keeps the running state as it is: a run that has not reported yet has not failed yet. */
function asFailed(state: ToolCallState): ToolCallState {
    if (state.isRunning) {
        return state;
    }
    return { ...state, isFailed: true, tone: 'failed', statusLabel: 'fehlgeschlagen' };
}
